__turbopack_context__.v({
  "blink": "intro-module-scss-module__BP-7gW__blink",
  "blinking": "intro-module-scss-module__BP-7gW__blinking",
  "intro": "intro-module-scss-module__BP-7gW__intro",
  "introContainer": "intro-module-scss-module__BP-7gW__introContainer",
  "introContent": "intro-module-scss-module__BP-7gW__introContent",
  "introDescription": "intro-module-scss-module__BP-7gW__introDescription",
  "introTitle": "intro-module-scss-module__BP-7gW__introTitle",
  "shadow": "intro-module-scss-module__BP-7gW__shadow",
  "typingCursor": "intro-module-scss-module__BP-7gW__typingCursor",
  "videoSection": "intro-module-scss-module__BP-7gW__videoSection",
  "videoWrp": "intro-module-scss-module__BP-7gW__videoWrp",
  "wavesImage": "intro-module-scss-module__BP-7gW__wavesImage",
  "wavesWrp": "intro-module-scss-module__BP-7gW__wavesWrp",
});
